"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Col_1 = tslib_1.__importDefault(require("react-bootstrap/Col"));
var Container_1 = tslib_1.__importDefault(require("react-bootstrap/Container"));
var Row_1 = tslib_1.__importDefault(require("react-bootstrap/Row"));
function Body(_a) {
    var children = _a.children;
    return (react_1.default.createElement("main", null,
        react_1.default.createElement(Container_1.default, { fluid: true },
            react_1.default.createElement(Row_1.default, null,
                react_1.default.createElement(Col_1.default, null, children)))));
}
exports.Body = Body;
//# sourceMappingURL=Body.js.map